import { AiLabelSection } from '../AiLabel'
import { FC } from 'react'
import { useClientPhotoStudio } from '../ClientPhotoStudio.context'

/** The AI label section (EU AI Act) wired to the Studio's AI label state — one per panel, one per combined run */
export const LabAiLabelSection: FC<{ isDisabled?: boolean, hideHeader?: boolean }> = ({ isDisabled = false, hideHeader = false }) => {
  const { aiLabelState, setAiLabelToggle, setAiLabelType, setAiLabelText, setAiLabelColour, setAiLabelOpacity, resetAiLabelPlacement } = useClientPhotoStudio()
  return (
    <AiLabelSection
      showAiLabel={aiLabelState.showAiLabel}
      onToggle={setAiLabelToggle}
      labelType={aiLabelState.labelType}
      onLabelTypeChange={setAiLabelType}
      labelText={aiLabelState.labelText}
      onLabelTextChange={setAiLabelText}
      colour={aiLabelState.colour}
      onColourChange={setAiLabelColour}
      opacity={aiLabelState.opacity}
      onOpacityChange={setAiLabelOpacity}
      onResetPlacement={resetAiLabelPlacement}
      isDisabled={isDisabled}
      hideHeader={hideHeader}
    />
  )
}
